import { AnyAction, Dispatch } from '@reduxjs/toolkit';
import {
    Currency,
    UserState,
    userSliceActions,
} from '../../../modules/main/slice/user';
// import { cmsDataSliceActions } from '../../../modules/main/slice/cmsData';
import { doRecycleIndex } from '@/hooks/useFavorite';
import { BetFormat } from '@/models/host/BetAmount';
import { analyticSliceActions } from '@/modules/analytic/slice';
import { batch } from 'react-redux';
import {
    betPlayersSliceActions,
    getNewPlayer,
} from '../../../modules/bet/players/slice';
import { resultProgressSliceActions } from '../../../modules/progress/slice/result';
import { progressTimeActions } from '../../../modules/progress/slice/time';
import { getLoginToken } from '../../../utils/commonFunc';
import { Progress } from '../../games/Progress';
import { CMDPsClientUiChange, CMDSpLogin, ICommand } from '../live';
import { AbstractHandler } from './AbstractHandler';

export class CMDSpLoginHandler extends AbstractHandler {
    _command: CMDSpLogin;
    _token: string;
    _sendCommand: (command: ICommand) => Promise<void>;
    constructor(
        command: ICommand,
        token: string,
        sendCommand: (command: ICommand) => Promise<void>
    ) {
        super();
        this._command = command as CMDSpLogin;
        this._token = token;
        this._sendCommand = sendCommand;
    }
    handle(dispatch: Dispatch<AnyAction>): void {
        const loginCommand = this._command;
        console.log('command::handler::login', loginCommand);
        const data = {} as UserState;
        data.AllowLoginSource = loginCommand.AllowLoginSource;
        data.CurrencyList = loginCommand.CurrencyList.map(
            c =>
                ({
                    CurrencyType: c.CurrencyType,
                    ExchangeRate: c.ExchangeRate,
                }) as Currency
        );
        data.CurrencyName = loginCommand.CurrencyName;
        data.CurrencyType = loginCommand.CurrencyType;
        data.ExchangeRate = 0;
        for (const c of data.CurrencyList) {
            if (c.CurrencyType === data.CurrencyType) {
                data.ExchangeRate = c.ExchangeRate;
                break;
            }
        }
        data.DuplicateLogin = loginCommand.DuplicateLogin === 1;
        data.ErrorMsgPack = loginCommand.ErrorMsgPack;
        data.FPlayerPrefs = loginCommand.FPlayerPrefs.toString();
        data.FPlayerPrefs2 = loginCommand.FPlayerPrefs2.toString();
        data.FPlayerPrefs3 = loginCommand.FPlayerPrefs3.toString();
        data.FPlayerPrefs4 = loginCommand.FPlayerPrefs4.toString();
        data.IsCommonWallet = loginCommand.IsCommonWallet === 1;
        data.LastLogin = loginCommand.LastLogin;
        data.LobbyCode = loginCommand.LobbyCode;
        data.LobbyType = loginCommand.LobbyType;
        data.MinimumToken = loginCommand.MinimumToken;
        data.NoChanceJackpot = loginCommand.NoChanceJackpot;
        data.PlayerID = loginCommand.PlayerID;
        data.PlayerPrefs = loginCommand.PlayerPrefs;
        data.PlayerPrefs2 = loginCommand.PlayerPrefs2;
        data.PlayerPrefs3 = loginCommand.PlayerPrefs3;
        data.PlayerPrefs4 = loginCommand.PlayerPrefs4;

        let newToken = getLoginToken(this._token, loginCommand.ReconnectKey);
        if (newToken[newToken.length - 1] == '2') {
            const cmd = new CMDPsClientUiChange();
            cmd.UIType = '1';
            cmd.currenttoken = newToken;
            this._sendCommand(cmd);
            newToken = newToken.substring(0, newToken.length - 1) + '1';
        }
        data.LoginToken = newToken;

        data.UNIXTimestamp = loginCommand.UNIXTimestamp;
        data.LoginTime = Date.now().valueOf(); // moment().valueOf();

        data.Username = loginCommand.Username;
        data.VideoToken = loginCommand.VideoToken;
        data.IsTrial = loginCommand.IsTrial === 1;
        data.IsAllowBlackJackSeat = loginCommand.IsAllowBlackJackSeat == 1;
        data.IsDemo = loginCommand.LobbyCode === 'eventdemo';
        data.NeedPrefsUpdate = false;
        data.isUpdateRecentlyPlayed = true;
        data.BetFormat = BetFormat.MANUAL_BET;
        data.IsInternalTest = loginCommand.InternalTestMode === 1; //tmp
        let needPayout: Array<string> = [];
        if (window.location.origin.indexOf('.compa.') > 0) {
            needPayout.push('testtwint');
        }
        data.showPayoutTable =
            needPayout.indexOf(loginCommand.LobbyCode.toLowerCase()) >= 0;
        data.blockLowRTP = false;
        data.HostListInited = false;

        if (!data.IsTrial && !data.IsDemo) {
            const fav = doRecycleIndex(data.FPlayerPrefs3);
            if (fav !== data.FPlayerPrefs3) {
                data.FPlayerPrefs3 = fav;
                data.NeedPrefsUpdate = true;
            }
        }

        const newPlayer = getNewPlayer(loginCommand.PlayerID);
        newPlayer.name = loginCommand.Username;
        batch(() => {
            dispatch(
                progressTimeActions.set({
                    key: 'launcher',
                    time: loginCommand.LoginLaucherUTCTime,
                })
            );
            dispatch(userSliceActions.updateData(data));
            //dispatch(cmsDataSliceActions.loadCmsData(loginCommand.LobbyCode));
            dispatch(
                resultProgressSliceActions.endLoad(
                    Progress.SERVER_USER_INFO_RESULT
                )
            );
            dispatch(betPlayersSliceActions.add(newPlayer));
            dispatch(
                analyticSliceActions.updateUserInfo({
                    playerID: loginCommand.PlayerID,
                    currency: loginCommand.CurrencyName,
                    lobbyCode: loginCommand.LobbyCode,
                })
            );
        });
        const time_change = window.localStorage.getItem('next_login_time');
        if (time_change) {
            dispatch(userSliceActions.updateNowTime(Number(time_change)));
            window.localStorage.removeItem('next_login_time');
        }
    }
}
